import classNames from 'classnames';

import { Link, Text } from '@farmersdog/corgi-x';
import { Back } from '@farmersdog/corgi-x/icons';

import { Picture } from '../../components/Picture';

import { variousDogBreedsSources } from './assets';
import styles from './DigestHighlightsSlice.css';

import type { DigestHighlightsSliceType } from './types';

interface BreedImageProps {
  breed: string;
}

interface DigestLinkProps {
  slice: DigestHighlightsSliceType;
}

function BreedImage({ breed }: BreedImageProps) {
  return (
    <div className={styles.leftColumn}>
      <Picture
        className={styles.img}
        sources={variousDogBreedsSources}
        alt={breed}
      />
    </div>
  );
}

function DigestLinks({ slice }: DigestLinkProps) {
  const links = slice.items;

  return (
    <ul className={classNames(styles.ul, styles.rightColumn)} role="list">
      {links.map(({ digestLink, digestLinkText }, i) => {
        return (
          <li className={styles.li} key={`digest-link-${i}`} role="listitem">
            <Link
              href={digestLink}
              baseColor="kale"
              className={styles.digestLink}
            >
              <Text variant="article-16" as="span">
                {digestLinkText}
              </Text>
              <Back baseColor="Carrot2" size={24} className={styles.front} />
            </Link>
          </li>
        );
      })}
    </ul>
  );
}

interface DigestProps {
  breed: string;
  slice: DigestHighlightsSliceType;
}

export function Digest({ breed, slice }: DigestProps) {
  return (
    <>
      <BreedImage breed={breed} />
      <DigestLinks slice={slice} />
    </>
  );
}
